'use strict';

class Header {
	constructor(){
		this.$header = $('.header');
		this.$menu = $('.header_menu');
		this.$nav = this.$header.find('.header_nav');

		this.isOPEN = false;
	}
	render(){
		this.menu();
		this.scrollHeader();
		this.dropdown();
		this.dropdownTouch();
		this.navLine();
		this.dropdownImage();
		this.lang();
		this.login();
	}
	/**
	 * 受講者ログイン
	 *  ヘッダーの「受講者ログイン」(.js_loginModal) から #logincontents をモーダルで開く。
	 *  旧サイトは magnific-popup だったが、仕組みはこのサイトに入っている modaal に寄せる。
	 *  modaal は inline が既定で、トリガーの href を中身の参照先として使う。
	 *
	 *  ログイン自体は旧サイト(/js/share.js)と同じ流れ。
	 *  /sender.php にID・パスワードをPOST → ワンタイムパスワードを受け取り、
	 *  隠しフォーム #otp_login を LearningWare のゲートウェイへsubmitする。
	 */
	login(){
		const $trigger = $('.js_loginModal');
		if( !$trigger.length || !$('#logincontents').length ) return;

		$trigger.on('click', (e)=>{
			e.preventDefault(); // ページ内リンクとして飛ぶのを止める
		}).modaal({
			type: 'inline',
			animation: 'fade',
			custom_class: 'modaal-login', // 見た目はこのクラス配下だけに閉じる
			// 設計の cover は rgba(21,39,84,.2) ＋ blur。ぼかしは .modaal-wrapper 側が
			// 持っているので、ここでは色だけ渡す（opacityを1にしないと色が薄まる）
			background: 'rgba(21, 39, 84, 0.2)',
			overlay_opacity: 1,
			before_open: ()=>{
				$('html').addClass('is-modal-open');
				// 背面のスクロールを止める。lenis を使っているので body の
				// overflow だけでは効かない。
				// サイト共通のインスタンスは app.lenis（InertialScroll.js）で、
				// window.lenis は会社概要ページ（Company.js）が別に持っているぶん。
				// このモーダルは全ページに出るので両方を見る（GetEntries.js と同じ）
				const lenis = (window.app && window.app.lenis) || window.lenis;
				if( lenis ) lenis.stop();
			},
			after_open: ($wrapper)=>{
				// lenis は停止中も wheel / touch を preventDefault するので、
				// 画面が低いときにモーダルの中をスクロールできなくなる。
				// data-lenis-prevent が付いた要素の中では lenis が手を引く
				$wrapper.attr('data-lenis-prevent', '');
			},
			after_close: ()=>{
				$('html').removeClass('is-modal-open');
				const lenis = (window.app && window.app.lenis) || window.lenis;
				if( lenis ) lenis.start();
			}
		});

		// modaal は開くときに中身をモーダル側へ移すので、document に委譲する
		$(document).on('click', '#btn_sso', (e)=>{
			e.preventDefault();
			const $btn = $(e.currentTarget);
			if( $btn.prop('disabled') ) return;
			$btn.prop('disabled', true);

			$.post('/sender.php', {
				login_id: $('#login_id').val(),
				password: $('#password').val()
			}, null, 'json')
				.done((res)=>{
					if( !res || res.result === 'NG' ) {
						window.alert(res && res.message ? res.message : 'ログインに失敗しました');
						return;
					}
					if( res.result === 'OK' ) {
						$('#login_sid').val(res.site_id);
						$('#login_lid').val(res.login_id);
						$('#login_ip').val(res.ip);
						$('#login_otp').val(res.otp);
						$('#otp_login').attr('action', res.base_url + '/otp-gateway/login').submit();
					}
				})
				.fail(()=>{
					window.alert('通信に失敗しました。時間をおいて再度お試しください。');
				})
				.always(()=>{
					$btn.prop('disabled', false);
				});
		});
	}
	menu(){
		this.$menu.on('click', ()=>{
			if( this.isOPEN ) {
				this.close();
			} else {
				this.open();
			}
			return false;
		});
		app.Util.layoutChange(()=>{
			this.close();
		});
	
		// $('.header_nav_menu a').on('click',(e)=>{
		// 	if( this.isOPEN ) {
		// 		 this.close();
		// 	}
		// });
	}
	open(){
		this.isOPEN = true;
		// this.$nav.scrollTop(0);
		$('html').addClass('drawerMenu-open');
		$('.header_nav_line').addClass('is-visible');
	}
	close(){
		this.isOPEN = false;
		// this.$nav.scrollTop(0);
		$('html').removeClass('drawerMenu-open');
		$('.header_nav_line').removeClass('is-visible');
	}

	scrollHeader(){
		//ヘッダースクロール		
		const header = document.querySelector('.header');
		const breadcrumb = document.querySelector('.m-breadcrumb');

		// スクロールイベントリスナーを追加
		const onScroll = () => {
			// メニューが開いている場合、スクロールヘッダーの機能を無効化
			if (this.isOPEN) return;

			const currentScrollY = window.scrollY;

			const isSmall = currentScrollY > 0;
			if (isSmall === header.classList.contains('is-small')) return;

			header.classList.toggle('is-small', isSmall);
			if (breadcrumb) {
				breadcrumb.classList.toggle('is-hidden', isSmall);
			}
			// is-small でメニューの余白が変わり、項目が横にずれる。
			// 保存済みの座標のままだと線だけ取り残されるので追従させる
			if (this.followNavLine) this.followNavLine();
		};

		// スクロールイベントリスナーの追加
		window.addEventListener('scroll', onScroll);
	}

	navLine(){
		const $menu = this.$nav.find('.header_nav_menu');
		const $line = $menu.find('.header_nav_menu_line');

		if( !$line.length ) return;

		// いま線を合わせている項目。ヘッダーの縮小中もこれを見て測り直す
		let $target = $();

		const setLine = ($label)=>{
			if( !$label.length ) return;
			$target = $label;
			$line.css({
				'--line-left': $label[0].offsetLeft,
				'--line-width': $label[0].offsetWidth,
			});
		};

		// メニューの余白は transition で動くため、切り替えた直後に測っても
		// まだ元の位置を返す。遷移が終わるまで毎フレーム測り直して追従させる
		this.followNavLine = ()=>{
			if( !$target.length ) return;
			const el = $line[0];
			el.style.transition = 'none'; // 追従中は線自身の遷移を切る（二重に遅れるため）
			const end = performance.now() + 600;
			const step = ()=>{
				setLine($target);
				if( performance.now() < end ) {
					requestAnimationFrame(step);
				} else {
					el.style.transition = '';
				}
			};
			requestAnimationFrame(step);
		};
		const reset = ()=>{
			let $current = $menu.find('.header_nav_menuItem.is-current .header_nav_menuItemLabel').first();
			if( !$current.length ) $current = $menu.find('.header_nav_menuItemLabel').first();
			setLine($current);
		};

		// 余白の遷移が終わった時点でも測り直す。
		// タブが非表示などで requestAnimationFrame が動かない場合の取りこぼしを防ぐ
		$menu.on('transitionend', (e)=>{
			const ev = e.originalEvent || e;
			if( ev.target !== $menu[0] ) return;
			if( ev.propertyName && ev.propertyName !== 'padding-right' ) return;
			setLine($target);
		});

		reset();

		$menu.find('.header_nav_menuItemLabel').on(app.Util.pointer('enter'), (e)=>{
			if( app.Util.touch() ) return;
			setLine($(e.currentTarget));
		});

		$menu.on(app.Util.pointer('leave'), ()=>{
			if( app.Util.touch() ) return;
			reset();
		});

		app.Util.resize(reset, '.header_nav_menu_line');
	}

	dropdown(){
		// TweenMax.delayedCall(0.8, ()=>{
			_.each(this.$nav.find('.has-dropdown'), (li)=>{
				let $li = $(li),
						$dropdown = $li.find('.js-dropdown');

				$li
					.on(app.Util.pointer('enter'), (e)=>{
						if(
							!app.Util.touch()
							&& (e.type == 'mouseenter' || e.pointerType == 'mouse')
						) {
							app.$html.addClass('nav-open');

						$li.addClass('is-open');

						}
					})
					.on(app.Util.pointer('leave'), (e)=>{
						if(
							!app.Util.touch()
							&& (e.type == 'mouseleave' || e.pointerType == 'mouse')
						) {

						app.$html.removeClass('nav-open');

						$li.removeClass('is-open');
						}
					});

				this.safeTriangle($li);
			// });
		});
	}

	/**
	 * タッチ操作でメガメニューを開く
	 *  メガメニューはホバーで開く作りなので、ホバーが無い操作（iPadやSurfaceの
	 *  タッチ、ペン）だと開けず、中のリンクに到達できない。ラベルへのタップで
	 *  開閉できるようにする。
	 *
	 *  マウス操作はこれまでどおりホバーのまま。直前のポインタ種別を見て、
	 *  touch / pen のときだけこの処理が走る。マウスとタッチが両方ある
	 *  ハイブリッド機（Surface等）でも、そのとき使った入力に合う挙動になる。
	 *
	 *  1回目のタップで開き、同じラベルをもう一度タップすると閉じる。
	 *  親ページへはメガメニュー内の見出しリンク（.header_nav_dropdownTtlLink）で行く。
	 *  SP幅はラベルがアコーディオンの開閉（Module.js）なので、PC幅のときだけ動かす。
	 */
	dropdownTouch(){
		const isPc = ()=> window.matchMedia('(min-width: 1024px)').matches;

		// click イベントからは入力の種別が取れないことがあるので、直前の
		// pointerdown / touchstart で覚えておく
		let lastPointerType = '';
		document.addEventListener('pointerdown', (e)=>{ lastPointerType = e.pointerType || ''; }, true);
		document.addEventListener('touchstart', ()=>{ lastPointerType = 'touch'; }, true);

		// ホバーできない環境は、種別が取れなくてもタップ扱いにする
		const isTouchInput = ()=> (
			lastPointerType === 'touch'
			|| lastPointerType === 'pen'
			|| !window.matchMedia('(hover: hover)').matches
		);

		const closeAll = ()=>{
			_.each(this.$nav.find('.has-dropdown.is-open'), (el)=>{
				el.classList.remove('is-open');
				const label = el.querySelector('.header_nav_menuItemLabel');
				if( label ) label.setAttribute('aria-expanded', 'false');
			});
			app.$html.removeClass('nav-open');
		};

		_.each(this.$nav.find('.has-dropdown'), (li)=>{
			const label = li.querySelector('.header_nav_menuItemLabel');
			if( !label || !li.querySelector('.js-dropdown') ) return;

			label.addEventListener('click', (e)=>{
				if( !isPc() || !isTouchInput() ) return;
				e.preventDefault();

				const willOpen = !li.classList.contains('is-open');
				closeAll();
				if( !willOpen ) return;

				li.classList.add('is-open');
				label.setAttribute('aria-expanded', 'true');
				app.$html.addClass('nav-open');
			});
		});

		// メニューの外をタップしたら閉じる
		document.addEventListener('click', (e)=>{
			if( !isPc() ) return;
			if( e.target.closest && e.target.closest('.has-dropdown') ) return;
			closeAll();
		});

		// キーボードでも閉じられるようにする
		document.addEventListener('keydown', (e)=>{
			if( e.key === 'Escape' ) closeAll();
		});

		// SP幅に変わったとき、開いたままの状態を残さない
		app.Util.resize(()=>{
			if( !isPc() ) closeAll();
		});
	}

	/**
	 * セーフトライアングル
	 *  ラベルからメガメニューへ斜めにカーソルを動かすと、途中で隣のメニュー項目に
	 *  ホバーが移ってしまいメニューが閉じる。これを防ぐため、カーソルとメガメニューの
	 *  上辺で作る三角形を li の疑似要素(.is-safearea:before)で敷き、その間だけ
	 *  隣の項目にホバーが渡らないようにする。
	 *  参考: https://ics.media/entry/260803/
	 *
	 *  三角形は開いている項目のラベルより下に敷く（ラベルは z-index:3）。
	 *  自分のラベルは覆わないので、カーソル追従もクリックも妨げない。
	 */
	safeTriangle($li){
		const li = $li[0],
					$label = $li.find('.header_nav_menuItemLabel'),
					$panel = $li.find('.header_nav_dropdownContainer'),
					panel = $panel[0];

		if( !panel ) return;

		// 頂点の高さ。カーソルからの相対で、+ が下。
		// 隣の項目のラベルに被る量を減らすため、-4（カーソルの少し上）から5px下げている。
		const APEX_Y = 1;

		const hide = ()=>{
			li.classList.remove('is-safearea');
		};

		$label.on(app.Util.pointer('move'), (e)=>{
			const ev = e.originalEvent || e;
			if( app.Util.touch() ) return;
			if( ev.pointerType && ev.pointerType != 'mouse' ) return;
			if( !li.classList.contains('is-open') ) return;

			const rect = panel.getBoundingClientRect(),
						top = ev.clientY + APEX_Y,
						height = rect.top - top;

			// メガメニューが真下にない（閉じかけ・SP幅など）ときは敷かない
			if( height < 4 || !rect.width ) return hide();

			li.style.setProperty('--safe-left', rect.left + 'px');
			li.style.setProperty('--safe-top', top + 'px');
			li.style.setProperty('--safe-width', rect.width + 'px');
			li.style.setProperty('--safe-height', height + 'px');
			// 頂点がメガメニューの横幅からはみ出さないように収める
			li.style.setProperty('--safe-x', Math.min(Math.max(ev.clientX - rect.left, 0), rect.width) + 'px');

			li.classList.add('is-safearea');
		});

		// 三角形の上にいる間は消さない（時間切れで撤去しない）。
		// メガメニューに入ったときと、項目そのものから出たときだけ撤去する。
		$panel.on(app.Util.pointer('enter'), hide);
		$li.on(app.Util.pointer('leave'), hide);
	}

	dropdownImage(){
		this.$nav.find('.header_nav_dropdownItem').each((i, item)=>{
			let $item = $(item),
					$images = $item.find('.header_nav_dropdownItemImg picture'),
					$links = $item.find('.header_nav_dropdownList li:not(.pc-hidden) a');

			if( !$images.length || !$links.length ) return;

			const setActive = (index)=>{
				$images.removeClass('is-active').eq(index).addClass('is-active');
			};

			$links.on(app.Util.pointer('enter'), (e)=>{
				if( app.Util.touch() ) return;
				setActive($links.index(e.currentTarget));
			});

			$item.on(app.Util.pointer('leave'), ()=>{
				if( app.Util.touch() ) return;
				setActive(0);
			});
		});
	}

	// 言語切替（JP）。クリックで開閉する
	lang(){
		let $lang = this.$header.find('.header_lang');
		if( !$lang.length ) return;

		let $ttl = $lang.find('.header_lang_ttl');

		const close = ()=>{
			if( !$lang.hasClass('is-open') ) return;
			$lang.removeClass('is-open');
			$ttl.attr('aria-expanded', 'false');
		};

		$ttl.on('click', (e)=>{
			e.preventDefault();
			e.stopPropagation();
			$lang.toggleClass('is-open');
			$ttl.attr('aria-expanded', $lang.hasClass('is-open') ? 'true' : 'false');
		});

		// 外側クリックで閉じる
		$(document).on('click', (e)=>{
			if( !$(e.target).closest('.header_lang').length ) close();
		});

		// Escで閉じる
		$(document).on('keydown', (e)=>{
			if( e.key == 'Escape' || e.keyCode == 27 ) close();
		});

		// PC/SP切り替え時はリセット
		app.Util.layoutChange(close);
	}

}

export default Header;
